<app-header></app-header>
<main class="flex min-h-screen flex-col pt-16 flex-1">
  <router-outlet />
</main>
<app-footer></app-footer>
<app-cookie-consent></app-cookie-consent>
<app-tour-prompt></app-tour-prompt>
<app-guided-tour
  [audience]="tourService.audience()"
  [visible]="tourService.visible()"
  [steps]="tourService.steps()"
  (visibleChange)="tourService.setVisible($event)">
</app-guided-tour>
